import { medium } from '../../../constants/fonts';
import { appConfig } from '../../../config/customization';

export default {
  wrapper: {
    width: '100%',
    fontSize: medium,
    textAlign: 'left',
    outline: 'none'
  },
  control: {
    width: '100%',
    border: 0,
    boxShadow: 'none'
  },
  menu: {
    borderColor: appConfig.colors.bordersGray
  },
  checkedOk: {
    strokeWidth: 2.4,
    stroke: appConfig.colors.primary,
    fill: 'none',
    marginRight: 0.5,
    paddingBottom: 3
  },
  selectedOption: {
    display: 'flex',
    outline: 'none',
    justifyContent: 'space-between'
  },
  normalOption: {
    display: 'flex',
    outline: 'none',
    justifyContent: 'flex-start'
  }
};
